import rounding from '@/util/rounding'
import { autoForm } from '@/util/getAutoForm'
import { apiQueryRate_USD_INR } from '@/resource'

export default {
  data() {
    const validateAmount = (rule, value, callback) => {
      if (value === '' || !Number(value)) {
        callback(new Error(this.$t('common.formValidation.amtReq')))
      } else if (parseFloat(value) < this.minLimit) {
        callback(new Error(this.$t('common.formValidation.amtLarger', { minLimit: this.minLimit })))
      } else if (this.rateChange > this.maxLimit) {
        callback(
          new Error(this.$t('common.formValidation.amtLess', { maxLimit: this.maxUSD, currency: this.accountCurrency }))
        )
      } else {
        callback()
      }
    }
    return {
      indiaIbtForm: {
        accountNumber: '',
        amount: '',
        vpa: '',
        mopCode: null, // For Dasshpe Netbanking and Wallet
        notes: '',
      },
      eeziePayRules: {
        accountNumber: [
          {
            required: true,
            message: this.$t('common.formValidation.accReq'),
            trigger: 'change',
          },
        ],
        amount: [
          {
            required: true,
            validator: validateAmount,
            trigger: 'blur',
          },
        ],
        vpa: [
          {
            required: true,
            message: this.$t('common.formValidation.dynamicReq', { dynamic: this.$t('common.field.vpa') }),
            trigger: 'blur',
          },
        ],
        mopCode: {
          required: true,
          message: this.$t('common.formValidation.dynamicReq', { dynamic: this.$t('common.field.bankName') }),
          trigger: 'blur',
        },
        notes: [
          {
            pattern: /^.{0,256}$/,
            message: this.$t('common.formValidation.note256'),
            trigger: 'blur',
          },
        ],
      },
      rate: 0.0,
      bankHTML: '',
      minLimit: 50,
      maxLimit: 50000,
      walletList: [], // For Dasshpe Wallet
      bankList: [], // For Dasshpe Netbanking
    }
  },
  computed: {
    rateChange() {
      return rounding(Math.ceil, this.rate * this.indiaIbtForm.amount, 0)
      // return rounding(Math.ceil, (this.rate * this.indiaIbtForm.amount).toPrecision(7), 2)
    },
    maxUSD() {
      return rounding(Math.floor, this.maxLimit / this.rate, 2)
    },
  },
  mounted() {
    this.queryRate()
  },
  methods: {
    setAccountNumber(accountNumber) {
      this.indiaIbtForm.accountNumber = accountNumber
    },
    queryRate() {
      apiQueryRate_USD_INR()
        .then(resp => {
          if (resp.data.code == 0) this.rate = this.initialRate(resp.data.data)
        })
        .catch(err => {
          this.errorMessage(
            this.$t('deposit.default.rate.result.rateError', { oldCurrency: 'USD', newCurrency: 'INR' })
          )
        })
    },
    success(msg) {
      this.bankHTML = autoForm(msg)
      if (this.bankHTML.length > 0) {
        this.$nextTick(function () {
          if (document.getElementById('AutoForm')) {
            document.getElementById('AutoForm').submit()
          } else {
            this.loading = false
            this.errorMessage(this.$t('deposit.default.failed'))
          }
        })
      } else {
        this.loading = false
        this.errorMessage(this.$t('deposit.default.failed'))
      }
    },
    submitForm() {
      this.$refs['indiaIbtForm'].validate(valid => {
        if (valid) {
          this.loading = true
          this.submitDeposit()
            .then(result => {
              this.depositSubmitWithRate(result, this.success)
            })
            .catch(err => {
              this.loading = false
              this.errorMessage(this.$t('deposit.default.failed'))
            })
        } else {
          return false
        }
      })
    },
  },
}
